import React, { useState, useEffect } from "react";
import SelectBox from "../../components/SelectBox";
import myConfig from "../../configs/config";
import { withTranslation } from "react-i18next";
import { Link, withRouter, useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { FaGasPump, FaSave, FaArrowLeft } from "react-icons/fa";
import "./FuelPump.css";

function FormFuelPump(props) {
  const farmId = props.match.params.farm_id;
  const fuelPumpId =
    props.match.params.fuel_pump_id === "add"
      ? -1
      : props.match.params.fuel_pump_id;

  let hasFuelPump = fuelPumpId !== -1;

  let history = useHistory();

  const [identification, setIdentification] = useState("");
  const [brand, setBrand] = useState("");
  const [fuelType, setFuelType] = useState("");
  const [capacity, setCapacity] = useState("");
  const [status, setStatus] = useState("active");
  const [location, setLocation] = useState("");
  const [installationDate, setInstallationDate] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [observations, setObservations] = useState("");
  const [title, setTitle] = useState("Cadastrar Bomba de Combustível");

  const fuelTypes = [
    { id: "diesel", name: "Diesel" },
    { id: "gasoline", name: "Gasolina" },
    { id: "ethanol", name: "Etanol" },
    { id: "biodiesel", name: "Biodiesel" },
    { id: "other", name: "Outro" },
  ];

  const statusOptions = [
    { id: "active", name: "Ativa" },
    { id: "inactive", name: "Inativa" },
    { id: "maintenance", name: "Em Manutenção" },
  ];

  useEffect(() => {
    document.title = `Agriconnected - ${title}`;

    if (hasFuelPump) {
      setTitle("Editar Bomba de Combustível");
      getCurrentFuelPump();
    }
  }, [hasFuelPump, title]);

  async function getCurrentFuelPump() {
    try {
      let FUEL_PUMP_URL = `${myConfig.API_URL}/fuel_pump/${fuelPumpId}/`;

      let response = await fetch(FUEL_PUMP_URL, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      let data = await response.json();

      if (data) {
        setIdentification(data.identification || "");
        setBrand(data.brand || "");
        setFuelType(data.fuel_type || "");
        setCapacity(data.capacity || "");
        setStatus(data.status || "active");
        setLocation(data.location || "");
        setInstallationDate(data.installation_date || "");
        setSerialNumber(data.serial_number || "");
        setObservations(data.observations || "");
      }
    } catch (error) {
      console.log(error);
      toast.error("Erro ao carregar dados da bomba de combustível");
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    // Validações básicas
    if (!identification.trim()) {
      toast.error("A identificação é obrigatória");
      return;
    }

    if (!fuelType) {
      toast.error("O tipo de combustível é obrigatório");
      return;
    }

    const fuelPumpData = {
      name: identification.trim(),
      brand: brand.trim(),
      fuel_type: fuelType,
      capacity: capacity ? parseFloat(capacity) : null,
      status: status,
      location: location.trim(),
      installation_date: installationDate || null,
      serial_number: serialNumber.trim(),
      observations: observations.trim(),
      farm_id: farmId,
      id: fuelPumpId,
    };

    try {
      let url = `https://agriconnected-ga4-default-rtdb.firebaseio.com/fuel-pumps.json`;
      let method = "POST";

      if (hasFuelPump) {
        url = `https://agriconnected-ga4-default-rtdb.firebaseio.com/fuel-pumps/${fuelPumpId}.json`;
        method = "PUT";
      }

      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(fuelPumpData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      if (response.status === 200 || response.status === 201) {
        toast.success(
          hasFuelPump
            ? "Bomba de combustível atualizada com sucesso!"
            : "Bomba de combustível cadastrada com sucesso!"
        );

        setTimeout(() => {
          history.push(`/${farmId}/fuel-pump/`);
        }, 2000);
      }
    } catch (error) {
      console.log(error);

      // For fetch, we need to handle errors differently
      if (error.message.includes("HTTP error!")) {
        // Try to get response body for detailed error info
        try {
          const match = error.message.match(/\d+/);
          const status = match ? parseInt(match[0]) : 0;

          switch (status) {
            case 400:
              toast.error("Dados inválidos. Verifique os campos preenchidos.");
              break;
            case 401:
              toast.error("Não autorizado. Faça login novamente.");
              break;
            case 403:
              toast.error("Você não tem permissão para realizar esta ação.");
              break;
            case 404:
              toast.error("Bomba de combustível não encontrada.");
              break;
            case 409:
              toast.error("Já existe uma bomba com esta identificação.");
              break;
            default:
              toast.error("Erro ao salvar bomba de combustível");
          }
        } catch (parseError) {
          toast.error("Erro ao salvar bomba de combustível");
        }
      } else {
        toast.error("Erro ao salvar bomba de combustível");
      }
    }
  }

  return (
    <div className="container-fluid">
      <ToastContainer />

      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4 className="card-title mb-0">
                <FaGasPump className="mr-2" />
                {title}
              </h4>
              <Link to={`/${farmId}/fuel-pump/`} className="btn btn-secondary">
                <FaArrowLeft className="mr-1" />
                Voltar
              </Link>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* Informações Básicas */}
                  <div className="col-md-6">
                    <h5 className="mb-3">Informações Básicas</h5>

                    <div className="form-group">
                      <label htmlFor="identification">
                        Identificação <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="identification"
                        value={identification}
                        onChange={(e) => setIdentification(e.target.value)}
                        placeholder="Ex: Bomba 01, BP-001"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="brand">Fabricante</label>
                      <input
                        type="text"
                        className="form-control"
                        id="brand"
                        value={brand}
                        onChange={(e) => setBrand(e.target.value)}
                        placeholder="Ex: Wayne, Gilbarco"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="fuelType">
                        Tipo de Combustível{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <SelectBox
                        id="fuelType"
                        value="name"
                        selected_value={fuelType}
                        data={fuelTypes}
                        change={(e) => setFuelType(e.target.value)}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="capacity">Capacidade (Litros)</label>
                      <input
                        type="number"
                        className="form-control"
                        id="capacity"
                        value={capacity}
                        onChange={(e) => setCapacity(e.target.value)}
                        placeholder="Ex: 10000"
                        min="0"
                        step="0.01"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="status">Status</label>
                      <SelectBox
                        id="status"
                        value={"name"}
                        selected_value={status}
                        data={statusOptions}
                        change={(e) => setStatus(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Informações Técnicas */}
                  <div className="col-md-6">
                    <h5 className="mb-3">Informações Técnicas</h5>

                    <div className="form-group">
                      <label htmlFor="location">Localização</label>
                      <input
                        type="text"
                        className="form-control"
                        id="location"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                        placeholder="Ex: Galpão Principal, Área de Abastecimento"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="serialNumber">Número de Série</label>
                      <input
                        type="text"
                        className="form-control"
                        id="serialNumber"
                        value={serialNumber}
                        onChange={(e) => setSerialNumber(e.target.value)}
                        placeholder="Número de série do equipamento"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="installationDate">
                        Data de Instalação
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="installationDate"
                        value={installationDate}
                        onChange={(e) => setInstallationDate(e.target.value)}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="observations">Observações</label>
                      <textarea
                        className="form-control"
                        id="observations"
                        rows="4"
                        value={observations}
                        onChange={(e) => setObservations(e.target.value)}
                        placeholder="Observações adicionais sobre a bomba de combustível"
                      />
                    </div>
                  </div>
                </div>

                <hr />

                <div className="row">
                  <div className="col-md-12">
                    <div className="d-flex justify-content-end">
                      <Link
                        to={`/${farmId}/fuel-pump/`}
                        className="btn btn-secondary mr-2"
                      >
                        Cancelar
                      </Link>
                      <button type="submit" className="btn btn-primary">
                        <FaSave className="mr-1" />
                        {hasFuelPump ? "Atualizar" : "Cadastrar"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(withRouter(FormFuelPump));
